// Test IDs for the home / landing feature. Naming follows the directive
// in ./auth.js (keys camelCase, values kebab-case `<feature>-<element>`).

export const HOME = {
        petsWall: 'home-pets-wall',
        petsWallItem: (id) => `home-pets-wall-${id}`,
        petsWallShare: (id) => `home-pets-wall-share-${id}`,
        photoOfWeek: 'home-photo-of-week',
        photoOfWeekTitle: 'home-photo-of-week-title',
        photoOfWeekProduct: 'home-photo-of-week-product',
        topRatedRow: 'home-top-rated-row',
        topRatedAll: 'home-top-rated-see-all',
        brandLogo: 'home-brand-logo',
        navLink: (id) => `home-nav-link-${id}`,
        heroTitle: 'home-hero-title',
        heroExploreButton: 'home-hero-explore-button',
        sectionsGrid: 'home-sections-grid',
        sectionCard: (id) => `home-section-card-${id}`,
        sectionLaunch: (id) => `home-section-launch-${id}`,
        footer: 'home-footer',
        footerLink: (id) => `home-footer-link-${id}`,
        footerSocial: (id) => `home-footer-social-${id}`,
        kiddee: 'home-kiddee-section',
        kiddeeVideo: 'home-kiddee-video',
        kiddeeClipDot: (i) => `home-kiddee-clip-dot-${i}`,
        kiddeeShopToy: 'home-kiddee-shop-this-toy',
        kiddeeAddToCart: 'home-kiddee-clip-add-to-cart',
        kiddeePhoto: (i) => `home-kiddee-photo-${i}`,
        kiddeeSocial: (id) => `home-kiddee-social-${id}`,
        sectionPage: (id) => `section-page-${id}`,
        sectionBackLink: 'section-back-home-link',
        mobileMenuButton: 'home-mobile-menu-button',
        mobileMenu: 'home-mobile-menu',
        mobileMenuLink: (id) => `home-mobile-menu-link-${id}`,
        storeInfo: 'home-store-info',
        storeAddress: 'home-store-address',
        storeEmail: 'home-store-email',
        storeHours: 'home-store-hours',
        storeMap: 'home-store-map',
        storeDirections: 'home-store-directions-link',
        discountBand: 'home-discount-band',
        storeShopButton: 'home-store-shop-button',
        storeShipping: 'home-store-shipping',
        gallery: 'home-gallery',
        galleryPhoto: (i) => `home-gallery-photo-${i}`,
        lightbox: 'home-lightbox',
        lightboxImage: 'home-lightbox-image',
        lightboxClose: 'home-lightbox-close',
        lightboxPrev: 'home-lightbox-prev',
        lightboxNext: 'home-lightbox-next',
        lightboxCounter: 'home-lightbox-counter',
        lightboxName: 'home-lightbox-product-name',
        lightboxPrice: 'home-lightbox-product-price',
        lightboxBuy: 'home-lightbox-buy-button',
        lightboxShare: 'home-lightbox-share-button',
        shareMenu: 'home-share-menu',
        shareSms: 'home-share-sms-link',
        shareFacebook: 'home-share-facebook-link',
        shareX: 'home-share-x-link',
        shareCopy: 'home-share-copy-button',
};
